import { defineStore } from "pinia";
import api from "@/api/login";
import router from "../router";
import { ElMessage, ElMessageBox } from "element-plus";
import storage from "@/utils/storage";
import routerFormat from "@/utils/router";
import { routes, notFoundRouter } from "@/router";
import { t, clearDataByType } from "@/utils";
export const useStore = defineStore("useStore", {
  state: () => ({
    token: storage.get("token") || "",
    theme: storage.get("theme") || "dark", // 主题
    info: {},
    addRouters: [],
    name: "",
    userMessage: [], // 消息列表
    sendMessageObject: {}, // 发送消息
    conversationItem: {}, // 当前选中的会话
    conversation: {}, // 接收的会话
    language: storage.get("language") || "en",
    connecting: false, // 连接状态
    conversationStatus: 1, // 会话状态 1：处理中2：已解决
    delMessage: {}, // 删除的消息
    scale: window.devicePixelRatio || 1, // 获取缩放比例
    ws: null,
    btnApi: [],
  }),
  getters: {
    myToken: (state) => state.token,
    myInfo: (state) => state.info,
    myName: (state) => state.name,
    routers: (state) => state.addRouters,
  },
  actions: {
    // 登陆
    async getLogin(val) {
      const {
        data: { data },
      } = await api.login(val);
      if (!data) return;
      // 存储token
      this.token = data.token;
      ElMessage.success(t("common.loginSuccess"));
      // 持久化存储token
      storage.set("token", data.token);
      router.replace("/");
    },
    // 客服登录
    async loginSitekey(userInfo) {
      const {
        data: { data },
      } = await api.kfLogin(userInfo);
      if (!data) return;
      this.token = data.token;
      ElMessage.success(t("common.loginSuccess"));
      // 持久化存储token
      storage.set("token", data.token);
      router.replace("/");
    },

    // 退出
    async getOut() {
      try {
        await ElMessageBox.confirm(t("action.logout"), t("action.tips"), {
          type: "warning",
        });
        await api.logout();
        this.clearInfo();
        storage.clear();
        ElMessage.success(t("common.logoutSuccess"));
      } catch (err) {
        console.log(err);
      }
    },
    // 清空用户信息
    clearInfo() {
      const key = [
        "token",
        "name",
        "btnApi",
        "conversationItem",
        "conversation",
        "userMessage",
      ];
      clearDataByType(this, key);
      storage.remove("token");
      router.replace("/login");
      console.log("退出登录");
    },
    // 获取用户信息
    async getInfo() {
      const { data } = await api.userInfo();
      if (data.code === 0) {
        this.name = data.data.name;
        this.setRouters(routerFormat(data.data.menuList));
        this.btnPermissions(data.data.menuList);
        this.info = data.data;
      }
      return data.code;
    },
    setRouters(routers) {
      this.addRouters = this.filterMenu(
        routers.concat(routes).concat(notFoundRouter)
      );
    },
    // 按钮接口
    btnPermissions(router) {
      router.forEach((item) => {
        if (item.children && item.children.length) {
          this.btnPermissions(item.children);
        } else {
          if (item.menuType === 2) {
            this.btnApi.push(item.interfacePath);
          }
        }
      });
    },
    // 递归过滤函数，过滤掉 menuType = 2 的菜单项
    filterMenu(menus) {
      return menus
        .filter((menuItem) => menuItem.menuType !== 2) // 过滤掉 menuType = 2 的项
        .map((menuItem) => {
          // 如果有 children，递归调用过滤函数
          if (menuItem.children && menuItem.children.length > 0) {
            return {
              ...menuItem,
              children: this.filterMenu(menuItem.children), // 递归过滤子菜单
            };
          }
          return menuItem;
        });
    },
    // 翻译语言
    setLanguage(lang) {
      this.language = lang;
      storage.set("language", lang);
    },
  },
});
